// Order-independent identity for the follows used to fetch a feed snapshot.
export const followingFeedIdentity = (speakerIds = [], podcastIds = []) =>
    JSON.stringify([[...speakerIds].sort(), [...podcastIds].sort()]);
